import React from "react";

import CardLink from "./CardLink";
import { Spinner } from "../../Component/Spinner";
import { observer } from "mobx-react";

interface CardProps {
    newObject?: boolean;
    saving?: boolean;
    saveError?: string | null;
    editable?: boolean;
    card: any;
    update?: Function;
    fields?: Array<string>;
    i?: number;
}

const setTitle = (ev: any, initialTitle: any, card: any, update: any) => {
    if (
        ev.currentTarget.innerText == initialTitle ||
        (ev.currentTarget.innerText == "" && initialTitle == undefined)
    )
        return;

    card.setTitle(ev.currentTarget.innerText);
    if (update) update();
};

const setDefinition = (ev: any, initialDefinition: any, card: any, update: any) => {
    if (
        ev.currentTarget.innerText == initialDefinition ||
        (ev.currentTarget.innerText == "" && initialDefinition == undefined)
    )
        return;
    card.setDefinition(ev.currentTarget.innerText);
    if (update) update();
};

const setOther = (ev: any, initialFact: any, card: any, update: any, factName: string) => {
    if (
        ev.currentTarget.innerText == initialFact[factName] ||
        (ev.currentTarget.innerText == "" && initialFact[factName] == undefined)
    )
        return;
    card.upsertFact(factName, ev.currentTarget.innerText);
    if (update) update();
};

const Card = observer(
    ({ card, fields, newObject, saving, saveError, editable = true, update, i }: CardProps) => {
        const initialTitle = card.title;
        const initialDefinition = card.definition;
        const initialFact = {};

        let textInput = null;

        let fieldsHTML: Array<JSX.Element> = [];
        if (fields) {
            fieldsHTML = fields.map((field, i: number) => {
                let cardValue = card.getFact(field).value;
                return (
                    <td
                        // ref={`card-definition-${i}`}
                        contentEditable={editable}
                        suppressContentEditableWarning={true}
                        id={`card-field-${i}`}
                        onBlur={ev =>
                            setOther(ev, initialFact, card, update, field)
                        }
                        key={i}
                    >
                        {cardValue}
                    </td>
                );
            });
        }

        return (
            <tr>
                <td style={{textAlign: "center"}}>
                    {card._id ? (
                        <>
                            <CardLink card={card} />
                            <Spinner show={!!saving} />
                            {saveError && (
                                <span className="modquiz-card-save-error" role="alert">
                                    {saveError}
                                </span>
                            )}
                        </>
                    ) : (
                        "New =>"
                    )}
                </td>

                <td
                    // ref={`card-title-${i}`}
                    contentEditable={editable}
                    suppressContentEditableWarning={true}
                    id="card-title"
                    onBlur={(ev: any) => setTitle(ev, initialTitle, card, update)}
                    ref={button => {
                        textInput = button;
                    }}
                >
                    {card.title}
                </td>
                <td
                    id="card-definition"
                    // ref={`card-definition-${i}`}
                    contentEditable={editable}
                    suppressContentEditableWarning={true}
                    onBlur={(ev: any) =>
                        setDefinition(ev, initialDefinition, card, update)
                    }
                >
                    {card.definition}
                </td>
                {fieldsHTML}
            </tr>
        );
    }
);

export default Card;
export { setTitle, setDefinition, setOther };
